// components/Filter.js
import React from "react";
import { motion } from "framer-motion";

const Filter = ({ selectedDate, setSelectedDate, isUse, setIsUse, onApplyFilter }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 mb-6"
    >
      <div className="flex flex-wrap gap-6 items-end">
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Chọn Ngày
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
                     bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                     focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent
                     transition duration-200 ease-in-out"
          />
        </div>

        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Trạng thái Sử dụng
          </label>
          <select
            value={isUse}
            onChange={(e) => setIsUse(e.target.value)}
            className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
                     bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                     focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent
                     transition duration-200 ease-in-out"
          >
            <option value="">Tất cả</option>
            <option value="true">Sử dụng</option>
            <option value="false">Không sử dụng</option>
          </select>
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onApplyFilter}
          className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-lg
                   hover:from-purple-700 hover:to-purple-900 focus:outline-none focus:ring-2 
                   focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800
                   transition duration-200 ease-in-out font-medium shadow-md hover:shadow-lg"
        >
          Áp dụng lọc
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Filter;
